<template>
  <v-card class="com-pc-card tm-pc-obs-list-frame">
    <div>
      <v-row class="com-pc-card-header tm-header-box">
        <span class="com-pc-card-title pb-1">{{ text.title }}</span>
        <v-tooltip bottom max-width="450px">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" color="white" class="ml-2 pb-1"
              >help_outline</v-icon
            >
          </template>
          <div>
            {{ this.$store.state.app.config.messageConfig.tmListToolTip }}
          </div>
          <span>
            <span>
              {{ legendStr.tmStg.tmStgMsg1 }}
              <br />
              {{ legendStr.tmStg.tmStgMsg2 }}
              <br />
            </span>
            <span class="text-flood-occurrence legend-stg-span mb-1">
              {{ legendStr.tmStg.occurrence }}
            </span>
            <br />
            <span class="text-flood-danger legend-stg-span mb-1">
              {{ legendStr.tmStg.danger }}</span
            >
            <br />
            <span class="text-flood-refuge legend-stg-span mb-1">
              {{ legendStr.tmStg.refuge }}
            </span>
            <br />
            <span class="text-flood-warn legend-stg-span mb-1">
              {{ legendStr.tmStg.warn }}
            </span>
          </span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <span v-if="pcPanelMode" class="tmList-time pr-4 pb-1">{{
          appTime
        }}</span>
        <v-tooltip left v-if="!pcPanelMode">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              dark
              small
              @click="changePanelMode(true)"
              class="pb-1"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>fullscreen</v-icon>
            </v-btn>
          </template>
          <span>{{ this.tooltipStr.panelModeOn }}</span>
        </v-tooltip>
        <v-tooltip left v-if="pcPanelMode">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              dark
              small
              @click="changePanelMode(false)"
              class="pb-1"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>fullscreen_exit</v-icon>
            </v-btn>
          </template>
          <span>{{ this.tooltipStr.panelModeOff }}</span>
        </v-tooltip>
      </v-row>
    </div>
    <v-col class="com-pc-card-contents">
      <v-row justify="center">
        <v-btn-toggle class="tm-btn-box" v-model="toggleIdx">
          <div
            v-for="(value, key) in selectObsDisp"
            :key="key"
            :class="key === 'stgDisp' ? '' : 'pl-1'"
            v-show="
              key === 'stgDisp' ||
              key === 'swstgDisp' ||
              key === 'cctvDisp' ||
              key === 'damDisp'
            "
          >
            <v-btn
              small
              color="success"
              class="tm-btn-list"
              :outlined="!selectObsDisp[key]"
              @click="changeTabFlag(key)"
            >
              <v-col>
                <v-row class="tm-btn-item">
                  <img :src="obsTabMaster[key].url" class="tm-btn-image" style="margin: auto"/>
                  <div class="pl-2 pt-1" style="white-space: pre-wrap">{{ obsTabMaster[key].label }}</div>
                </v-row>
              </v-col>
            </v-btn>
          </div>
        </v-btn-toggle>
      </v-row>
      <v-row class="pt-1" justify="center">
        <v-btn-toggle class="tm-btn-box" v-model="toggleIdx">
          <div
            v-for="(value, key) in selectObsDisp"
            :key="key"
            :class="key === 'rnDisp' ? '' : 'pl-1'"
            v-show="
              key === 'rnDisp' ||
              key === 'coastDisp' ||
              key === 'snwDisp' ||
              key === 'qwtrDisp'
            "
          >
            <v-btn
              small
              color="success"
              class="tm-btn-list"
              :outlined="!selectObsDisp[key]"
              :disabled="isNoActive(key)"
              @click="changeTabFlag(key)"
            >
              <v-col>
                <v-row class="tm-btn-item">
                  <img :src="obsTabMaster[key].url" class="tm-btn-image" />
                  <div class="pl-2 pt-1">{{ obsTabMaster[key].label }}</div>
                </v-row>
              </v-col>
            </v-btn>
          </div>
        </v-btn-toggle>
      </v-row>
    </v-col>
    <div class="tm-box com-pc-card-contents">
      <div class="vc-tab">
        <v-btn
          class="vc-tab-btn mr-2"
          :class="{ 'com-btn-on': tabIndex === 0 }"
          @click="changeTabIndex(0)"
          >{{ text.tab.twn }}</v-btn
        >
        <v-btn
          class="vc-tab-btn"
          :class="{ 'com-btn-on': tabIndex === 1 }"
          @click="changeTabIndex(1)"
          >{{ text.tab.rsys }}</v-btn
        >
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              rounded
              depressed
              outlined
              icon
              color="success"
              class="mr-2"
              :disabled="!showAllOpenBtn"
              v-show="tabIndex === 0 && !twnFullOpenFlg && !twnFullOpenReadyFlg"
              @click="setTwnFullOpenFlg()"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon size="32px">unfold_more</v-icon>
            </v-btn>
          </template>
          <span>{{ this.tooltipStr.fullOpen }}</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              rounded
              depressed
              outlined
              loading
              icon
              color="success"
              class="mr-2"
              v-show="tabIndex === 0 && twnFullOpenReadyFlg"
              @click="setTwnFullOpenFlg()"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon class="vc-tab-all-open-btn" size="32px"
                >unfold_less</v-icon
              >
            </v-btn>
          </template>
          <span>{{ this.tooltipStr.fullClose }}</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              rounded
              depressed
              outlined
              icon
              color="success"
              class="mr-2"
              :disabled="!showAllOpenBtn"
              v-show="
                (tabIndex === 0 &&
                  twnFullOpenFlg &&
                  !twnFullOpenReadyFlg &&
                  twnFullOpenEndFlg) ||
                (tabIndex === 0 &&
                  twnFullOpenFlg &&
                  !twnFullOpenReadyFlg &&
                  !twnFullOpenEndFlg)
              "
              @click="setTwnFullOpenFlg()"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon class="vc-tab-all-open-btn" size="32px"
                >unfold_less</v-icon
              >
            </v-btn>
          </template>
          <span>{{ this.tooltipStr.fullClose }}</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              rounded
              depressed
              outlined
              icon
              color="success"
              class="mr-2"
              :disabled="!showAllOpenBtn"
              v-show="tabIndex === 1 && !rysyFullOpenFlg"
              @click="setRsysFullOpenFlg()"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon size="32px">unfold_more</v-icon>
            </v-btn>
          </template>
          <span>{{ this.tooltipStr.fullOpen }}</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              rounded
              depressed
              outlined
              loading
              icon
              color="success"
              class="mr-2"
              v-show="tabIndex === 1 && rsysFullOpenReadyFlg"
              @click="setRsysFullOpenFlg()"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon class="vc-tab-all-open-btn" size="32px"
                >unfold_less</v-icon
              >
            </v-btn>
          </template>
          <span>{{ this.tooltipStr.fullClose }}</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              rounded
              depressed
              outlined
              icon
              color="success"
              class="mr-2"
              :disabled="!showAllOpenBtn"
              v-show="
                (tabIndex === 1 &&
                  rysyFullOpenFlg &&
                  !rsysFullOpenReadyFlg &&
                  rsysFullOpenEndFlg) ||
                (tabIndex === 1 &&
                  rysyFullOpenFlg &&
                  !rsysFullOpenReadyFlg &&
                  !rsysFullOpenEndFlg)
              "
              @click="setRsysFullOpenFlg()"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon class="vc-tab-all-open-btn" size="32px"
                >unfold_less</v-icon
              >
            </v-btn>
          </template>
          <span>{{ this.tooltipStr.fullClose }}</span>
        </v-tooltip>
      </div>
      <v-col class="tm-box-list">
        <div v-if="tabIndex === 0" class="tm-list">
          <tm-twn-list :selectObsDispPt="selectObsDisp"></tm-twn-list>
        </div>
        <div v-if="tabIndex === 1" class="tm-list">
          <tm-rsys-list :selectObsDispPt="selectObsDisp"></tm-rsys-list>
        </div>
      </v-col>
    </div>
  </v-card>
</template>

<script>
import Util from "./../../lib/util.js";
import mixin from "./../../lib/mixin.js";
import TmTwnList from "./TmTwnList.vue";
import TmRsysList from "./TmRsysList.vue";
export default {
  components: {
    TmTwnList,
    TmRsysList,
  },
  name: "tm-list-flame",
  mixins: [mixin],
  data() {
    return {
      obsTabMaster: {
        stgDisp: {
          label: "水位観測",
          url: "/kawabou/img/obs_icons/obs_water.svg",
        },
        swstgDisp: {
          label: this.$store.state.app.config.replaceNameConfig.swstgLF,
          url: "/kawabou/img/obs_icons/obs_swstg.svg",
        },
        cctvDisp: {
          label: "カメラ　",
          url: "/kawabou/img/obs_icons/obs_camera.svg",
        },
        damDisp: {
          label: "ダム　　",
          url: "/kawabou/img/obs_icons/obs_dam.svg",
        },
        rnDisp: {
          label: "雨量　　",
          url: "/kawabou/img/obs_icons/obs_rain.svg",
        },
        coastDisp: {
          label: "海岸　　",
          url: "/kawabou/img/obs_icons/obs_sea.svg",
        },
        snwDisp: {
          label: "積雪　　",
          url: "/kawabou/img/obs_icons/obs_snow.svg",
        },
        qwtrDisp: {
          label: "水質　　",
          url: "/kawabou/img/obs_icons/obs_quality.svg",
        },
      },
      /** 文字列リソース */
      text: {
        title: "地図中の観測所一覧",
        tab: {
          twn: "市町村別",
          rsys: "河川別",
        },
      },
      befTabIndex: 0,
      toggleIdx: 0,
    };
  },
  created: function () {
    // 観測所表示設定
    this.selectObsDisp = this.$store.state.Telemeter.selectObsDisp[0];
    switch (this.viewContents) {
      case 0:
        break;
      case 1:
        this.selectObsDisp.stgDisp = false;
        this.selectObsDisp.swstgDisp = false;
        this.selectObsDisp.cctvDisp = false;
        this.selectObsDisp.damDisp = false;
        this.selectObsDisp.rnDisp = false;
        this.selectObsDisp.coastDisp = true;
        this.selectObsDisp.snwDisp = true;
        this.selectObsDisp.qwtrDisp = true;
        break;
      case 2:
        this.selectObsDisp.stgDisp = false;
        this.selectObsDisp.swstgDisp = false;
        this.selectObsDisp.cctvDisp = false;
        this.selectObsDisp.damDisp = false;
        this.selectObsDisp.rnDisp = true;
        this.selectObsDisp.coastDisp = false;
        this.selectObsDisp.snwDisp = false;
        this.selectObsDisp.qwtrDisp = false;
        break;
      case 3:
        this.selectObsDisp.stgDisp = false;
        this.selectObsDisp.swstgDisp = false;
        this.selectObsDisp.cctvDisp = false;
        this.selectObsDisp.damDisp = false;
        this.selectObsDisp.rnDisp = false;
        this.selectObsDisp.coastDisp = false;
        this.selectObsDisp.snwDisp = false;
        this.selectObsDisp.qwtrDisp = false;
        break;
    }
  },
  computed: {
    /** 表示日時 */
    appTime: {
      get() {
        return Util.formatDate(this.$store.state.app.appTime);
      },
    },
    /** PCパネル拡大表示モード */
    pcPanelMode: {
      get() {
        return this.$store.state.app.pcPanelMode;
      },
    },
    /** 観測所一覧選択タブ */
    tabIndex: {
      get() {
        if (
          this.$store.state.Telemeter.tmListTabIndex == 0 ||
          this.$store.state.Telemeter.tmListTabIndex == 1
        ) {
          return this.$store.state.Telemeter.tmListTabIndex;
        } else {
          // MBモードで「市町村別(0)」「河川別(1)」以外を選択した場合、
          // PCモードに切り替えた際には「市町村別(0)」を表示する
          return 0;
        }
      },
    },
    /** 観測所一覧全開閉フラグ */
    twnFullOpenFlg: {
      get() {
        return this.$store.state.Telemeter.tmListTwnFullOpenFlg;
      },
    },
    /** 観測所一覧全開閉準備フラグ */
    twnFullOpenReadyFlg: {
      get() {
        return this.$store.state.Telemeter.tmListTwnFullOpenReadyFlg;
      },
    },
    /** 観測所一覧全開閉データ取得完了フラグ */
    twnFullOpenEndFlg: {
      get() {
        return this.$store.state.Telemeter.tmListTwnFullOpenEndFlg;
      },
    },
    /** 観測所一覧水系別全開閉フラグ */
    rysyFullOpenFlg: {
      get() {
        return this.$store.state.Telemeter.tmlistRsysFullOpenFlg;
      },
    },
    /** 観測所一覧水系別全開閉準備フラグ */
    rsysFullOpenReadyFlg: {
      get() {
        return this.$store.state.Telemeter.tmListRsysFullOpenReadyFlg;
      },
    },
    /** 観測所一覧水系別全開閉データ取得完了フラグ */
    rsysFullOpenEndFlg: {
      get() {
        return this.$store.state.Telemeter.tmListRsysFullOpenEndFlg;
      },
    },
    /** 観測所一覧全開閉ボタン表示 */
    showAllOpenBtn: {
      get() {
        if (this.tabIndex === 0) {
          // 市町村別の場合
          return (
            this.$store.state.map.mapConfig.zoomTmListShowFullOpenBtnByTwn <=
            this.$store.state.map.zoom
          );
        } else {
          // 水系別の場合
          return (
            this.$store.state.map.mapConfig.zoomTmListShowFullOpenBtnByRsys <=
            this.$store.state.map.zoom
          );
        }
      },
    },
    /** ツールチップ共通文言 */
    tooltipStr: {
      get() {
        return this.$store.state.app.config.messageConfig.commonTooltip;
      },
    },
    /** 凡例共通文言 */
    legendStr: {
      get() {
        return this.$store.state.app.config.messageConfig.legendMsg;
      },
    },
    /** 表示コンテンツ設定 */
    viewContents: {
      get() {
        return this.$store.state.map.viewContents;
      },
    },
  },
  methods: {
    changeTabFlag(key) {
      this.selectObsDisp[key] = !this.selectObsDisp[key];
    },
    changeTabIndex(num) {
      this.$store.commit("Telemeter/setSelectTmListTabIndex", num);
    },
    setTwnFullOpenFlg() {
      let flg;
      if (this.twnFullOpenFlg) {
        flg = false;
        this.$store.commit("Telemeter/setTmListTwnFullOpenEndFlg", flg);
      } else {
        flg = true;
      }
      this.$store.commit("Telemeter/setTmListTwnFullOpenFlg", flg);
    },
    setRsysFullOpenFlg() {
      let flg;
      if (this.rysyFullOpenFlg) {
        flg = false;
        this.$store.commit("Telemeter/setTmListRsysFullOpenEndFlg", flg);
      } else {
        flg = true;
      }
      this.$store.commit("Telemeter/setTmListRsysFullOpenFlg", flg);
    },
    changePanelMode(bln) {
      this.$log.debug("[tmList]act - pchangePanelMode(" + bln + ")");
      if (bln) {
        this.replacePanelMode("1");
        this.$store.commit("app/setPcPanelModeContent", "tmList");
      } else {
        this.replacePanelMode("0");
        this.$store.commit("app/setPcPanelModeContent", null);
      }
      this.$store.commit("app/setPcPanelMode", bln);
    },
    isNoActive(key) {
      if (
        global.KWB_MODE === "reduction" &&
        (key === "coastDisp" || key === "snwDisp" || key === "qwtrDisp")
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    tabIndex() {
      //  観測所一覧選択タブが変更された場合、全展開フラグをOFFにする。
      if (this.tabIndex != this.befTabIndex) {
        this.$log.debug(
          "[tmList] this.tabIndex !== this.befTabIndex:" +
            (this.tabIndex != this.befTabIndex)
        );
        this.befTabIndex = this.tabIndex;

        this.$store.commit("Telemeter/setTmListTwnFullOpenFlg", false);
        this.$store.commit("Telemeter/setTmListTwnFullOpenReadyFlg", false);
        this.$store.commit("Telemeter/setTmListTwnFullOpenEndFlg", false);

        this.$store.commit("Telemeter/setTmListRsysFullOpenFlg", false);
        this.$store.commit("Telemeter/setTmListRsysFullOpenReadyFlg", false);
        this.$store.commit("Telemeter/setTmListRsysFullOpenEndFlg", false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tmList-time {
  color: white;
}
</style>
